import type { Optional } from '@festina-life/core'
import type { FPlusCodeEditorLanguageServerInput } from '@festina-life/fplus'
import { useMemo } from 'react'

import { useLayoutContext } from '../../context/layoutContext'
import { useDocumentationSiteLinkTransformer } from '../../hooks/useDocumentationSiteLinkTransformer'
import { useConfigurationLanguageServerInputInitializer } from './useConfigurationLanguageServerInputInitializer'

export const useFPlusCodeEditorContext = ({
  expressionPath,
  prefixFunctionDeclaration,
}: {
  expressionPath?: string
  prefixFunctionDeclaration: Optional<string>
}): FPlusCodeEditorLanguageServerInput => {
  const documentationTransformer = useDocumentationSiteLinkTransformer()
  const { preferences } = useLayoutContext()
  const inputProvider = useConfigurationLanguageServerInputInitializer()

  return useMemo(
    () => ({
      textTransformer: documentationTransformer,
      hoverOnCtrl: preferences.templates.isFPlusHoverWithCtrlHover,
      languageServerInput: inputProvider({
        expressionPath,
        prefixFunctionDeclaration,
      }),
    }),
    [
      documentationTransformer,
      preferences.templates.isFPlusHoverWithCtrlHover,
      inputProvider,
      expressionPath,
      prefixFunctionDeclaration,
    ],
  )
}
